import React from 'react';
import {Tab, Tabs} from 'react-bootstrap';
import PrinterHistory from './PrinterHistory';
import PrinterConsumables from './PrinterConsumables';
import {useMediaQuery} from '../hooks';

/** Ten sam próg co .printer-details-grid w _custom.scss */
const NARROW = '(max-width: 64em)';

type Props = {
  printer: number
}

const PrinterPanels = ({printer}: Props) => {

  const isNarrow = useMediaQuery(NARROW);

  if (isNarrow) return <div className="settings-section printer-panels-tabs">
    <Tabs defaultActiveKey="history" id="printerPanelsTabs">
      <Tab eventKey="history" title="Historia drukarki">
        <PrinterHistory printer={printer} showHeader={false} />
      </Tab>
      <Tab eventKey="consumables" title="Wymiany materiałów">
        <PrinterConsumables printerId={printer} showHeader={false} />
      </Tab>
    </Tabs>
  </div>;

  return <div className="printer-panels-grid">
    <PrinterHistory printer={printer} />
    <PrinterConsumables printerId={printer} />
  </div>;
}

export default PrinterPanels;
